import { motion } from "framer-motion";

const SECTION_IMG = "https://customer-assets.emergentagent.com/job_qr-wash-earn/artifacts/phagavdd_1000004485.png";

export default function WhatIsSection() {
  return (
    <section
      id="what-is"
      data-testid="what-is-section"
      className="py-24 sm:py-32 px-6 sm:px-12 lg:px-24"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500 mb-4 block">
            The Network
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-white mb-6">
            What is AnyWash Pass?
          </h2>
          <p className="text-base leading-relaxed text-neutral-400 mb-4">
            AnyWash Pass is a monthly car wash membership that gives customers unlimited washes
            at participating locations across the DFW area.
          </p>
          <p className="text-base leading-relaxed text-neutral-400 mb-4">
            As a partner, you receive a steady flow of new customers who are already paying members
            — all they need to do is check in at your location using a simple QR code.
          </p>
          <p className="text-base leading-relaxed text-neutral-400">
            You wash the car, select the wash type, and get paid weekly. It's that simple.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.15 }}
          className="relative"
        >
          <div className="rounded-2xl overflow-hidden border border-neutral-800">
            <img
              src={SECTION_IMG}
              alt="Professional car wash facility"
              className="w-full h-[400px] lg:h-[500px] object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
